/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "gccadhoctaskingapi",
            "endpoint": "https://w1b1ukzw20.execute-api.ap-southeast-1.amazonaws.com/master",
            "region": "ap-southeast-1"
        },
        {
            "name": "gccfaceprintapi",
            "endpoint": "https://13stoawbc8.execute-api.ap-southeast-1.amazonaws.com/master",
            "region": "ap-southeast-1"
        },
        {
            "name": "gccfeedbackapi",
            "endpoint": "https://ojg4laqmh0.execute-api.ap-southeast-1.amazonaws.com/master",
            "region": "ap-southeast-1"
        },
        {
            "name": "gccgrouptagapi",
            "endpoint": "https://wj1x17dk4k.execute-api.ap-southeast-1.amazonaws.com/master",
            "region": "ap-southeast-1"
        },
        {
            "name": "gcckeywordmgtapi",
            "endpoint": "https://v9692yzafl.execute-api.ap-southeast-1.amazonaws.com/master",
            "region": "ap-southeast-1"
        },
        {
            "name": "gcctaskingapi",
            "endpoint": "https://wpr1pndqul.execute-api.ap-southeast-1.amazonaws.com/master",
            "region": "ap-southeast-1"
        },
        {
            "name": "gcctaskquotaapi",
            "endpoint": "https://bqdt95gqpk.execute-api.ap-southeast-1.amazonaws.com/master",
            "region": "ap-southeast-1"
        },
        {
            "name": "gccusermapapi",
            "endpoint": "https://svsji3r9bj.execute-api.ap-southeast-1.amazonaws.com/master",
            "region": "ap-southeast-1"
        }
    ],
    "aws_cognito_identity_pool_id": "ap-southeast-1:a42c01f9-adc3-43c0-9ef3-0ecf37888b84",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_P14BkVTve",
    "aws_user_pools_web_client_id": "75ngsebj7qqk4r940cag8m62n7",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "ap-southeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "gccadhoctasking-master",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "gccfaceprint-master",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "gccfeedback-master",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "gccgrouptag-master",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "gcckeywordmgt-master",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "gcctasking-master",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "gcctaskquota-master",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "gccusermap-master",
            "region": "ap-southeast-1"
        }
    ],
    "aws_user_files_s3_bucket": "hunnycloudgccs3fad92-master",
    "aws_user_files_s3_bucket_region": "ap-southeast-1"
};


export default awsmobile;
